import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  // LinearProgress,
  Box
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from '@material-ui/core';
import { background, secondarySc50 } from 'common/colors';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';

const styles = theme => ({
  appbar: {
    boxShadow: 'none',
    maxWidth: '500px',
    margin: '0 auto',
    right: 'auto',
    backgroundColor: background
  },
  appbarTransparent: {
    boxShadow: 'none',
    maxWidth: '500px',
    margin: '0 auto',
    right: 'auto',
    backgroundColor: 'transparent'
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    color: 'white',
    fontFamily: 'Lato',
    lineHeight: '24px'
  },
  toolbar: {
    width: '100%'
  },
  progressiveBar: {
    borderRadius: 0,
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: secondarySc50
    }
  },
  buttonHelpTransparent: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '8px'
  },
  buttonHelpNoTransparent: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '8px',
    border: `2px solid ${theme.palette.common.neutralNr30}`,
    borderRadius: '8px',
    padding: '4px 8px'
  }
});

const MainAppBarSuplesi = ({
  classes,
  title = '',
  icon,
  type = 'default',
  onClick,
  variant,
  titleAlign = 'left',
  color,
  iconHelp,
  iconInfo,
  onClickInfo,
  history,
  next,
  setError
}) => {
  const onBack = () => {
    history.goBack();
  };

  const getAction = () => {
    if (onClick) return onClick;

    if (type === 'close') {
      return () => history.push('/home');
    }

    return onBack;
  };

  return (
    <>
      <AppBar className={classes.appbarTransparent}>
        <Toolbar className={classes.toolbar}>
          {icon !== 'hide' && (
            <IconButton
              aria-label="menu"
              className={classes.menuButton}
              color={variant === 'transparent' ? 'inherit' : 'default'}
              edge="start"
              onClick={() => {
                const action = getAction();

                action();
                next();
              }}
            >
              {type === 'close' ? <CloseIcon /> : <ArrowBackIcon />}
            </IconButton>
          )}
          <Typography
            className={classes.title}
            style={{
              textAlign: titleAlign || 'center',
              color: color ? 'black' : 'white',
              paddingRight: '30'
            }}
            variant="h5"
          >
            {title}
          </Typography>
          {iconHelp && (
            <Box
              className={
                variant === 'transparent'
                  ? classes.buttonHelpTransparent
                  : classes.buttonHelpNoTransparent
              }
              onClick={() => setError('contact-cs')}
            >
              <img alt="icon" src="/images/assets/help_icon.svg" />
              <Typography
                className={classes.title}
                style={{
                  textAlign: 'right',
                  color: color ? 'black' : 'white',
                  paddingRight: '30'
                }}
                variant="h5"
              >
                Bantuan
              </Typography>
            </Box>
          )}
          {iconInfo && (
            <IconButton
              aria-label="menu"
              color={variant === 'transparent' ? 'inherit' : 'default'}
              edge="end"
              onClick={onClickInfo}
            >
              <InfoIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
      {/*{type === 'form' ? (*/}
      {/*  <div style={{ height: '10px', margin: '0 auto' }}>*/}
      {/*    <LinearProgress*/}
      {/*      className={classes.progressiveBar}*/}
      {/*      value={percent}*/}
      {/*      variant="determinate"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*) : null}*/}
    </>
  );
};

export default withStyles(styles)(MainAppBarSuplesi);
